export default "__VITE_ASSET__OfjLybnU__"